import React from 'react';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';

/**
 * Renders `loader` with the query's data. Nothing is shown while the query loads, unless a `fallback`
 * element is given, which is shown in its place until the data arrives.
 */
export const LoadMore = ({query, loader, children, variables, alwaysRender, fallback, ...props}) => {
	return (
		<ForecastQueryRenderer
			query={query}
			showLoader={!!fallback}
			customLoader={fallback ? () => fallback : undefined}
			variables={variables}
			alwaysRender={alwaysRender}
			render={(relayProps, retry) => {
				return React.cloneElement(loader, {retry, ...relayProps, ...props}, children);
			}}
		/>
	);
};
